<template lang="html">
    <div v-if="(typeof menus.Main != 'undefined')" class="component__main-menu can-scroll" ref="component">
        <ul class="main-menu__submenu">
            <li class="main-menu__item" v-if="canViewDashboard">
                <router-link v-bind:to="{ name: 'Index'}" v-bind:class="{[settingsLinkActiveClass]: $route.name === 'Index'}">
                    <md-icon>home</md-icon>
                    <span>Dashboard</span>
                </router-link>
            </li>
        </ul>

        <component v-bind:is="menu" v-for="menu in accessMainMenus" v-bind:key="menu.name"></component>

        <ul class="main-menu__submenu">
            <li class="main-menu__item has-arrow has-droprdown">
                <a @click.prevent.stop="$root.toggleMenu($event)">
                    <md-icon class="arrow-icon-right">keyboard_arrow_right</md-icon>
                    <md-icon class="arrow-icon-down">keyboard_arrow_down</md-icon>
                    <md-icon>android</md-icon>
                    <span>Приложение</span>
                </a>

                <ul class="main-menu__submenu">
                    <li class="main-menu__item">
                        <a v-on:click="getAPKLink('storekeeper')">
                            <md-icon>get_app</md-icon>
                            <span>Кладовщик</span>
                        </a>
                        <a v-on:click="getAPKLink('forwarder')">
                            <md-icon>get_app</md-icon>
                            <span>Экспедитор</span>
                        </a>                        
                    </li>
                </ul>
            </li>
        </ul>

        <ul class="main-menu__submenu foregin">
            <li class="main-menu__item">
                <a v-if="(config && config.other && config.other.menuDocsLink)" v-bind:href="config.other.menuDocsLink" target="_blank">
                    <md-icon>integration_instructions</md-icon>
                    <span>Инструкции</span>
                </a>
                <a v-if="(config && config.other && config.other.menuVersionLink)" v-bind:href="config.other.menuVersionLink" target="_blank">
                    <md-icon>history</md-icon>
                    <span>История версий</span>
                </a>
                <a>
                    <md-icon>system_update_alt</md-icon>
                    <span>{{this.$root.appVersion}}</span>
                </a>
                <a>
                    <md-icon>settings_suggest</md-icon>
                    <span>{{this.$root.appHash}}</span>
                </a>                
            </li>
        </ul>

    </div>
</template>
<script>
    export default {
        name: 'main-menu',
        props: [
            'module_id',
            'entity',
            'entity_id'
        ],
        data() {
            return {
                apk: null,
                canViewDashboard: true
            }
        },
        created() {
            this.$nextTick(() => {
                this.checkAccessDashboard();
            });
        },
        watch: {
            'user'(user) {
                this.checkAccessDashboard();
            },
            'accessMainMenus'(menus) {
                this.$nextTick(() => this.handleRightSubMenu())
            }
        },
        computed: {
            menus() {
                return this.$root.menus
            },
            access() {
                return this.$store.state.module.accessModules;
            },
            accessMainMenus() {
                let result = {};
                if (!this.menus || !this.menus.Main || !Object.keys(this.menus.Main) || !this.access || !Object.keys(!this.access)) return result;

                Object.keys(this.menus.Main).map(key => {
                    let item = this.menus.Main[key];
                    if (this.access[item.module]) result[key] = item;
                });

                return result;
            },
            user() {
                return this.$store.state.users.current;
            },
            settingsLinkActiveClass() {
                return this.$router.options.settingsLinkActiveClass;
            },
            settingLink() {
                if (!this.$route.meta || !this.$route.meta.setting_link) return '';
                return this.$route.meta.setting_link
            }            
        },
        methods: {
            handleRightSubMenu() {
                if (!this.$refs.component) return;
                const RightItems = this.$refs.component.querySelectorAll('.has-dropright');
                [...RightItems].map(li => {
                    const SubMenu = li.querySelector('.main-menu__item__dropright-menu');
                    if (SubMenu) li.addEventListener('mouseenter', () => {
                        const rect = li.getBoundingClientRect();
                        
                        SubMenu.style.top  = `${rect.top}px`;
                        SubMenu.style.left = `${rect.left + rect.width}px`;

                        SubMenu.style.display = 'block';
                        setTimeout(() => (SubMenu.style.opacity = 1), 10)
                    });

                    if (SubMenu) li.addEventListener('mouseleave', () => {
                        SubMenu.style.opacity = 0;
                        setTimeout(() => (SubMenu.style.display = 'none'), 310)
                    });
                })
            },
            getAPKLink(type) {
                this.$store.dispatch('module/getAPKLink', type).then(r => {
                    if (r && r.link) {
                        let download = window.open(r.link);
                        if (download) download.focus();
                    }
                });
            },
            checkAccessDashboard() {
                this.$root.isAuth().then(user => {
                    if (user && user.groups) {
                        let isStoreKeeper = user.groups.find(item => item.code === "storekeepers");
                        if (isStoreKeeper) this.canViewDashboard = false;
                        else this.canViewDashboard = true;
                    }
                });
            }
        }
    }
</script>
<style lang="sass">
    .component__main-menu
        display: flex
        flex-direction: column
        align-items: stretch
        justify-content: flex-start
        height: 100%
        padding: 0 8px 0 0
        overflow: auto

        .md-divider
            width: 100%
  
        .main-menu__submenu
            width: 100%
            margin: 0
            padding: 0 0 0 8px
            list-style: none
            &.foregin
                margin: auto 0 0 0
        .main-menu__item
            display: flex
            align-items: center
            justify-content: flex-start
            flex-direction: column
            margin: 0
            padding: 0
            width: 100%
            a
                display: flex
                align-items: center
                justify-content: flex-start
                width: 100%
                margin: 4px 0
                padding: 8px
                border-radius: 3px
                transition: .3s cubic-bezier(.25,.8,.25,1)
                transition-property: color, background-color, opacity
                text-decoration: none !important
                color: #000
                cursor: pointer

                &.action-link
                    .md-menu
                        margin: auto 0 auto auto
                        .md-button
                                .md-icon, .md-icon.small
                                    margin: 0
                &:hover
                    background-color: #ebebeb
                    color: #000
                &.setting-link-active
                    background: #11a7f3
                    color: #fff
                    .md-icon
                        color: #fff

                .md-icon
                    margin: 0 8px 0 0
                span
            
            .main-menu__submenu
                padding-left: 16px
  
            &.has-droprdown
                a
                    > .md-icon.arrow-icon-right
                        display: inline-flex
                    > .md-icon.arrow-icon-down
                        display: none
                > .main-menu__submenu
                    display: none
                &.active
                    a
                        > .md-icon.arrow-icon-right
                            display: none
                        > .md-icon.arrow-icon-down
                            display: inline-flex
                    > .main-menu__submenu
                        display: block

            &.has-dropright
                position: relative
            .main-menu__item__dropright-menu
                display: none
                position: fixed
                left: 100%
                top: 0
                max-width: 600px
                opacity: 0
                transition: .3s cubic-bezier(.25, .8, .25,1)
            .main-menu__item__dropright-menu__container
                display: flex
                flex-wrap: wrap
                border: 1px solid #e0e0e0
                border-radius: 3px
                box-shadow: -2px 0px 10px 2px rgba(0, 0, 0, 0.2)
                background-color: #fff
                width: 600px
                .main-menu__item__dropright-menu__section
                    display: flex
                    flex-direction: column
                    width: 50%
                a, .main-menu__item__dropright-menu__title
                    width: calc(100% - 8px)
                    padding: 10px
                    margin: 4px
</style>



// WEBPACK FOOTER //
// MainMenu.vue?b246e89a